import "../styles/dlink.less";

import dlink from "../lib/dlink";

HFN.dLink = dlink;
